import styled from 'styled-components'

import { theme } from 'styles/theme'

import { fluidType } from '../fluid-type'

const { colors, lineHeights, media, radii, space } = theme

export { Section } from 'components/general-styles/General'

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xxl']};

  @media (${media.desktop}) {
    flex-direction: row;
    align-items: center;
    gap: 3.72%;
  }
`

export const Infos = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space['spacing-xl']};

  h2,
  h2 span {
    margin: 0;
    font-size: ${fluidType.sectionTitle};
    line-height: ${lineHeights['font-line-height-sm']};
    letter-spacing: -0.02em;
  }

  .ds-button {
    justify-content: center;
    gap: ${space['spacing-xs']};
    border-radius: ${radii['corner-radius-pill']};
  }

  @media (${media.desktop}) {
    flex: 0 0 43.28%;
    gap: 1.875rem;

    .ds-button {
      /* 334px do desenho. */
      width: 20.875rem;
      margin-top: 1.25rem;
    }
  }
`

export const Paragraphs = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xl']};

  p {
    margin: 0;
  }
`

const FRAME_OFFSET = 'clamp(0.75rem, 1.1vw, 1rem)'

const FRAME_RADIUS = '2.5rem'

const FRAME_STROKE = '1.5px'

export const Frames = styled.div`
  position: relative;
  padding: ${FRAME_OFFSET};

  @media (${media.desktop}) {
    flex: 0 0 53%;
  }
`

const Frame = styled.div`
  position: absolute;
  width: calc(100% - 2 * ${FRAME_OFFSET});
  height: calc(100% - 2 * ${FRAME_OFFSET});
  border-width: ${FRAME_STROKE};
  border-style: solid;
  border-radius: ${FRAME_RADIUS};
`

export const FrameCyan = styled(Frame)`
  top: 0;
  left: 0;
  border-color: ${colors['cyan-text-contrast']};
`

export const FrameMagenta = styled(Frame)`
  right: 0;
  bottom: 0;
  border-color: ${colors['pink-text-contrast']};
`

export const Video = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: ${FRAME_RADIUS};

  img,
  iframe {
    display: block;
    width: 100%;
    height: auto;
  }
`
